import { IUserInfo } from './ekonomiskAnalysInitQueryUtils';
import { ISelectedAnalys, IGrundurval } from '../EkonomiskAnalysPage';
import {
  IAnalys,
  ISelection,
} from '../Queries/EkonomiskAnalysInitQuery/EkonomiskAnalysInitQuery';
import { IStartAnalysInfo } from '../Components/SideMenu/EkonomiskAnalysSelect/Components/FavoriteAnalysDialog/Queries/ChangeStartAnalysMutation/ChangeStartAnalysMutation';
import Logger from '../../../../../../Utils/Logger';
import { USE_NEW_AS_START_ANALYS_ID } from '../Components/SideMenu/EkonomiskAnalysSelect/Components/FavoriteAnalysDialog/EkonomiskAnalysFavoriteAnalysDialog';
import {
  getNewAnalys,
  NEW_ANALYS_ID_KOD,
  NEW_ANALYS_RAPPORT_ID,
} from '../Components/SideMenu/Components/CreateNewAnalys/CreateNewAnalysUtils';
import {
  IColumn,
  ISumCategory,
} from '../Queries/EkonomiskAnalysSettingsQuery/EkonomiskAnalysSettingsQuery';
import { StandardColumnType } from '../Components/SideMenu/Components/PeriodOchKolumner/EditColumn/Components/Queries/EkonomiskAnalysStandardColumnQuery/EkonomiskAnalysStandardColumnQuery';
import { IEkonomiskAnalysDates } from '../Components/AnalysSettingsHandler/AnalysSettingsHandler';
import { AvenyCollectionMap } from '../../../../../../Model/ModelContext/ModelContext';
import { kodplaner_ekkodplaner } from 'src/Components/KodplanManager/Queries/_QueryTypes/kodplaner';

export const getSelectedAnalys = (
  availableReports: ISelection[],
  analysInfo: IStartAnalysInfo
): ISelectedAnalys | null => {
  const analysId = getAnalysId(availableReports, analysInfo);

  if (!analysId) {
    return null;
  }

  const kodbehorighet = availableReports.find(
    x => x.id === analysInfo.kodbehorighet
  );

  if (!kodbehorighet) {
    Logger.error(
      Error(`Kunde inte hitta kodbehörighet: ${analysInfo.kodbehorighet}`)
    );
    return null;
  }

  const analys = kodbehorighet.analysList.find(
    x =>
      x.id === analysId &&
      (analysInfo.utdelningLopnr !== undefined
        ? x.utdelatLopnr === analysInfo.utdelningLopnr
        : true)
  );

  if (!analys) {
    Logger.error(
      Error(
        `Kunde inte hitta analys med id: ${analysId} och utdelning löpnr: ${analysInfo.utdelningLopnr}`
      )
    );
    return null;
  }

  return {
    analys: {
      grundurval:
        analys.baseSelection &&
        analys.baseSelection.id &&
        analys.baseSelection.name
          ? { id: analys.baseSelection.id, name: analys.baseSelection.name }
          : undefined,
      id: analysId,
      idkod: analys.idkod ?? NEW_ANALYS_ID_KOD,
      utdelningLopnr: analys.utdelatLopnr,
      name: analys.name,
      categoryID: analys.kategori_ID,
      detaljanalys: analys.detaljanalys ?? undefined,
      ai_prompt: analys.ai_prompt ?? undefined,
    },
    codePrivilege: {
      id: kodbehorighet.id,
      name: kodbehorighet.name,
      anvandsFor: kodbehorighet.anvandsFor,
      analysList: kodbehorighet.analysList,
    },
  };
};

export const getAnalysFromUserId = (
  activeKodplanId: string,
  availableReports: ISelection[],
  availableCategories: ISumCategory[],
  standardColumns: StandardColumnType[] | undefined,
  dates: IEkonomiskAnalysDates,
  avenyCollectionMap: AvenyCollectionMap,
  userInfo: IUserInfo | undefined,
  helaHuvudboken: IGrundurval | undefined,
  newAnalysColumns: IColumn[],
  activeKodplan?: kodplaner_ekkodplaner
): ISelectedAnalys | null => {
  if (
    userInfo &&
    userInfo.startAnalys &&
    userInfo.startAnalys.rapportId === USE_NEW_AS_START_ANALYS_ID
  ) {
    return {
      analys: {
        ...getNewAnalys(
          availableCategories,
          standardColumns,
          dates,
          avenyCollectionMap,
          newAnalysColumns,
          activeKodplan
        ),
        id: NEW_ANALYS_RAPPORT_ID,
        idkod: NEW_ANALYS_ID_KOD,
        utdelningLopnr: 1,
        name: 'Namnlös Analys',
        grundurval: helaHuvudboken,
      },
      codePrivilege: {
        id: userInfo.startAnalys.kodbehorighet,
        name: 'Hela huvudboken',
      },
    };
  } else if (
    userInfo &&
    userInfo.startAnalys &&
    userInfo.startAnalys.kodplanId === activeKodplanId
  ) {
    return getSelectedAnalys(availableReports, userInfo.startAnalys);
  } else {
    return null;
  }
};

export const getAnalysId = (
  availableReports: ISelection[],
  analysInfo: IStartAnalysInfo
): string | null => {
  if (analysInfo.idKod) {
    const kodbehorighet = availableReports.find(
      x => x.id === analysInfo.kodbehorighet
    );
    if (kodbehorighet) {
      const analys = kodbehorighet.analysList.find(
        x => x.idkod !== undefined && x.idkod === analysInfo.idKod
      );
      return analys ? analys.id : null;
    }
    return null;
  }

  return analysInfo.rapportId ? analysInfo.rapportId : null;
};

export const getForceHelarsJamforelse = (
  harPeriodiseradBudget: boolean,
  preferHelarsjamforelse?: boolean
): boolean => {
  return !harPeriodiseradBudget ? true : preferHelarsjamforelse ?? true;
};

export const getAnalysByIDKod = (
  idKod: string,
  reports: ISelection[]
): IAnalys | null => {
  for (const report of reports) {
    const foundAnalys = report.analysList.find(
      analys => analys.idkod === idKod
    );
    if (foundAnalys) {
      return foundAnalys;
    }
  }

  return null;
};
